import {Card, Col, message, Row, Statistic, Steps, Tag, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faListCheck} from "@fortawesome/free-solid-svg-icons";
import {
    step_1_active_img,
    step_1_inactive_img,
    step_2_active_img,
    step_2_inactive_img,
    step_3_active_img,
    step_3_inactive_img,
    step_4_active_img,
    step_4_inactive_img,
    step_5_active_img,
    step_5_inactive_img,
    step_6_active_img,
    step_6_inactive_img,
    step_7_active_img,
    step_7_inactive_img,
    step_8_active_img,
    step_8_inactive_img,
    step_9_active_img,
    step_9_inactive_img,
} from "../../../../AppImageConst";
import {
    CalendarOutlined,
    ClockCircleOutlined,
    FileDoneOutlined,
    UserOutlined,
    VideoCameraOutlined
} from "@ant-design/icons";
import {useEffect, useState} from "react";
import adminService from "../../../service/adminService";
import {MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {CustomerJourneyStatusDto} from "../../../dto/admin/CustomerJourneyStatusDto";
import CommonFunction from "../../../util/CommonFunction";
import {ACCOUNT_TYPE, IDENTIFICATION_SOURCE} from "../../../util/Constants";

const {Paragraph} = Typography;

const CustomerJourneyStatusViewPage = (props: any) => {
    const [userDetail, setUserDetail] = useState<CustomerJourneyStatusDto>();
    const [isJointAccount, setJointAccount] = useState<boolean>(false);
    const [adminStep, setAdminStep] = useState<number>(-1);
    const [stepData, setStepData] = useState<{ currentStep: number, completedStep: number }>({
        currentStep: -1,
        completedStep: -1
    });
    useEffect(() => {
        const customerIdentityStr = localStorage.getItem("customerIdentity");
        const customerIdentityDto = customerIdentityStr !== null ? JSON.parse(customerIdentityStr) : null;
        fetchUserDetails(customerIdentityDto.identificationSource, customerIdentityDto.identificationSourceValue)
    }, [])

    const fetchUserDetails = (identificationSource: number, identificationSourceValue: string) => {
        adminService.getCustomerJourneyStatus(identificationSourceValue, identificationSource).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                setUserDetail(results)
                let jointAccountStatus = results.accountType == ACCOUNT_TYPE.JOINT_ACCOUNT;
                setJointAccount(jointAccountStatus)
                setStepData({currentStep: checkValue(results.currentStep), completedStep: (jointAccountStatus && results.isTimeSlotSelected) ? 8 : (!jointAccountStatus && results.isTimeSlotSelected) ? 7 : checkValue(results.completedStep) - 1})
            } else {
                message.error(MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const checkValue = (value: any) => {
        if (null == value) {
            return -1;
        }
        return value;
    }
    useEffect(() => {
        if (userDetail) {
            let adminLevelCurrentStatus = getAdminLevelCurrentStatus(userDetail);
            setAdminStep(adminLevelCurrentStatus);
        }
    }, [userDetail]);
    const getColor = (identificationSourceType: string | undefined) => {
        if (undefined != identificationSourceType) {
            switch (identificationSourceType) {
                case IDENTIFICATION_SOURCE.NIC: {
                    return 'green';
                }
                case IDENTIFICATION_SOURCE.PP: {
                    return 'geekblue';
                }
                case IDENTIFICATION_SOURCE.DL: {
                    return 'volcano';
                }
            }
        }
    }
    const getColorOfJointAccountTemplate = (status: string | undefined) => {
        if (undefined != status) {
            switch (status) {
                case "ACCEPTED": {
                    return 'green';
                }
                case "REJECTED": {
                    return 'volcano';
                }
            }
        }else {
            return "yellow";
        }
    }

    const getJointApplicantStatus = (data: string | undefined) => {
        switch (data) {
            case "IN_PROGRESS":
                return <Tag color='yellow'>In Progress</Tag>
            case "ACCEPTED":
                return <Tag color='green'>Accepted</Tag>
            default:
                return <Tag color='volcano'>Rejected</Tag>
        }
    }

    const onboardProcessItems = [
        {
            title: "Personal Details",
            icon: <img className={stepData.completedStep >= 0 ? 'active-step' : 'inactive-step'}
                       src={stepData.completedStep >= 0 ? step_1_active_img : step_1_inactive_img} alt={''}/>,
            description: (
                <span className={
                    stepData.completedStep >= 0
                        ? 'completed-description'
                        : stepData.completedStep === -1
                            ? 'inprogress-description'
                            : 'pending-description'
                }>
                {stepData.completedStep >= 0 ? 'Completed' : stepData.completedStep === -1 ? 'In Progress' : 'Pending'}
            </span>
            ),
        },
        {
            title: "Address Details",
            icon: <img className={stepData.completedStep >= 1 ? 'active-step' : 'inactive-step'}
                       src={stepData.completedStep >= 1 ? step_2_active_img : step_2_inactive_img} alt={''} />,
            description: (
                <span className={
                    stepData.completedStep >= 1
                        ? 'completed-description'
                        : stepData.completedStep === 0
                            ? 'inprogress-description'
                            : 'pending-description'
                }>
                {stepData.completedStep >= 1 ? 'Completed' : stepData.completedStep === 0 ? 'In Progress' : 'Pending'}
            </span>
            ),
        },
        {
            title: "Invest Details",
            icon: <img className={stepData.completedStep >= 2 ? 'active-step' : 'inactive-step'}
                       src={stepData.completedStep >= 2 ? step_3_active_img : step_3_inactive_img} alt={''} />,
            description: (
                <span className={
                    stepData.completedStep >= 2
                        ? 'completed-description'
                        : stepData.completedStep === 1
                            ? 'inprogress-description'
                            : 'pending-description'
                }>
                {stepData.completedStep >= 2 ? 'Completed' : stepData.completedStep === 1 ? 'In Progress' : 'Pending'}
            </span>
            ),
        },
        {
            title: "Bank Details",
            icon: <img className={stepData.completedStep >= 3 ? 'active-step' : 'inactive-step'}
                       src={stepData.completedStep >= 3 ? step_4_active_img : step_4_inactive_img} alt={''} />,
            description: (
                <span className={
                    stepData.completedStep >= 3
                        ? 'completed-description'
                        : stepData.completedStep === 2
                            ? 'inprogress-description'
                            : 'pending-description'
                }>
                {stepData.completedStep >= 3 ? 'Completed' : stepData.completedStep === 2 ? 'In Progress' : 'Pending'}
            </span>
            ),
        },
        {
            title: "Other Details",
            icon: <img className={stepData.completedStep >= 4 ? 'active-step' : 'inactive-step'}
                       src={stepData.completedStep >= 4 ? step_5_active_img : step_5_inactive_img} alt={''} />,
            description: (
                <span className={
                    stepData.completedStep >= 4
                        ? 'completed-description'
                        : stepData.completedStep === 3
                            ? 'inprogress-description'
                            : 'pending-description'
                }>
                {stepData.completedStep >= 4 ? 'Completed' : stepData.completedStep === 3 ? 'In Progress' : 'Pending'}
            </span>
            ),
        },
        {
            title: "Attachments",
            icon: <img className={stepData.completedStep >= 5 ? 'active-step' : 'inactive-step'}
                       src={stepData.completedStep >= 5 ? step_6_active_img : step_6_inactive_img} alt={''} />,
            description: (
                <span className={
                    stepData.completedStep >= 5
                        ? 'completed-description'
                        : stepData.completedStep === 4
                            ? 'inprogress-description'
                            : 'pending-description'
                }>
                {stepData.completedStep >= 5 ? 'Completed' : stepData.completedStep === 4 ? 'In Progress' : 'Pending'}
            </span>
            ),
        },
        {
            title: "Acknowledgement",
            icon: <img className={stepData.completedStep >= 6 ? 'active-step' : 'inactive-step'}
                       src={stepData.completedStep >= 6 ? step_7_active_img : step_7_inactive_img} alt={''} />,
            description: (
                <span className={
                    stepData.completedStep >= 6
                        ? 'completed-description'
                        : stepData.completedStep === 5
                            ? 'inprogress-description'
                            : 'pending-description'
                }>
                {stepData.completedStep >= 6 ? 'Completed' : stepData.completedStep === 5 ? 'In Progress' : 'Pending'}
            </span>
            ),
        },
        ...(isJointAccount ? [{
            title: "Second Holder Details",
            icon: <img className={stepData.completedStep >= 7 ? 'active-step' : 'inactive-step'}
                       src={stepData.completedStep >= 7 ? step_8_active_img : step_8_inactive_img} alt={''} />,
            description: (
                <span className={
                    stepData.completedStep >= 7
                        ? 'completed-description'
                        : stepData.completedStep === 6
                            ? 'inprogress-description'
                            : 'pending-description'
                }>
                {stepData.completedStep >= 7 ? 'Completed' : stepData.completedStep === 6 ? 'In Progress' : 'Pending'}
            </span>
            ),
        }] : []),
        {
            title: "Time Slot Selection",
            icon: <img className={userDetail?.isTimeSlotSelected ? 'active-step' : 'inactive-step'}
                       src={userDetail?.isTimeSlotSelected ? step_9_active_img : step_9_inactive_img} />,
            description: (
                <span className={userDetail?.isTimeSlotSelected ? 'completed-description' : 'pending-description'}>
                {userDetail?.isTimeSlotSelected ? 'Completed' : 'Pending'}
            </span>
            ),
        }
    ];

    const getAdminStatus = (status: string | undefined) => {
        if (undefined != status) {
            switch (status) {
                case "VERIFIED": {
                    return "Completed";
                }
                case "ORIGINALLY_SEEN": {
                    return "Originally Seen";
                }
                case "RESCHEDULED": {
                    return "Rescheduled";
                }
                case "PENDING": {
                    return "Pending";
                }
                case "DECLINED": {
                    return "Declined";
                }
                case "REJECTED": {
                    return "Rejected";
                }
            }
        } else {
            return "Pending"
        }
    }

    const videoVerificationProcessItems = [
        {
            title: "Document Verification",
            icon: <FileDoneOutlined style={{ fontSize: 28 }} className={getAdminStatus(userDetail?.documentVerificationStatus)}/>,
            description: (
                <span className={getAdminStatus(userDetail?.documentVerificationStatus)}>
                {getAdminStatus(userDetail?.documentVerificationStatus)}
            </span>
            ),
        },
        {
            title: "Video Verification",
            icon: <VideoCameraOutlined style={{ fontSize: 28 }} className={getAdminStatus(userDetail?.videoVerificationStatus)} />,
            description: (
                <span className={getAdminStatus(userDetail?.videoVerificationStatus)}>
                {getAdminStatus(userDetail?.videoVerificationStatus)}
            </span>
            ),
        },
        {
            title: "Customer Verification",
            icon: <UserOutlined style={{ fontSize: 28 }} className={getAdminStatus(userDetail?.customerVerificationStatus)}/>,
            description: (
                <span className={getAdminStatus(userDetail?.customerVerificationStatus)}>
                {getAdminStatus(userDetail?.customerVerificationStatus)}
            </span>
            ),
        },
    ];


    const getAdminLevelCurrentStatus = (data: any): number => {
        const statuses = [
            data.documentVerificationStatus,
            data.videoVerificationStatus === "ORIGINALLY_SEEN" ? "VERIFIED" : data.videoVerificationStatus,
            data.customerVerificationStatus,
        ];

        const highestIndex = statuses.lastIndexOf("VERIFIED");
        return highestIndex !== -1 ? highestIndex : -1;
    };


    return (
        <div>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="page-header-main-title-col">
                    <h2 className="page-header-main-title"
                        style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <div className="header_icon header-icon-center">
                            <FontAwesomeIcon icon={faListCheck}/>
                        </div>
                        Customer Journey View
                    </h2>
                </Col>
            </Row>

            <Row gutter={[16, 24]} style={{marginTop: 8}}>
                <Col span={24}>
                    <Card className="customer-journy-customer-info-card-body" size="small">
                        <Row gutter={[12, 12]}>
                            <Col span={8}>
                                <Statistic title="Username" value={CommonFunction.validateText(userDetail?.username)}/>
                            </Col>
                            <Col span={8}>
                                <Statistic title="User Type" value={undefined == userDetail?.accountType ? "Pending" : ACCOUNT_TYPE.INDIVIDUAL_ACCOUNT == userDetail?.accountType ? "Individual User" : "Joint User"}/>
                            </Col>
                            <Col span={8}>
                                <Statistic title="Identification Source" formatter={() => {
                                    return (<Tag
                                        color={getColor(userDetail?.identificationSource)}>{CommonFunction.validateText(userDetail?.identificationSource)}</Tag>)
                                }}/>
                            </Col>
                            <Col span={8}>
                                <Statistic title="Identification Value"
                                           value={CommonFunction.validateText(userDetail?.identificationValue)}
                                           formatter={(value: string) => value.replace(',', '')}/>
                            </Col>
                            <Col span={8}>
                                <Statistic title="Mobile Number"
                                           value={CommonFunction.validateText(userDetail?.mobileNumber)}
                                           formatter={(value: string) => value.replace(',', '')}/>
                            </Col>
                            <Col span={8}>
                                <Statistic title="Email" value={CommonFunction.validateText(userDetail?.email)}/>
                            </Col>

                        </Row>
                    </Card>
                </Col>

                <Col span={24}>
                    <Card className={'customer-journey-stepper-card'}>
                        <Row gutter={[12, 12]}>
                            <Col span={24}>
                                <Steps current={stepData.completedStep} labelPlacement="vertical"
                                       items={onboardProcessItems} size="small" className={'customer-journey-stepper'}/>
                            </Col>
                        </Row>
                    </Card>
                </Col>

                <Col span={24}>
                    <Card title={'Admin Verification Process'}
                          className={'video-verification-info-card'}>
                        <Row gutter={[12, 12]}>
                            <Col span={16}>
                                <Steps current={adminStep} labelPlacement="vertical"
                                       items={videoVerificationProcessItems} size="small"
                                       className={'video-verification-info-stepper'}/>
                            </Col>

                            {0 == adminStep ?
                                <Col span={8} className={'video-verification-date-time-col'}>
                                    <h3>Video Verification on</h3>

                                    <Row>
                                        <Col span={24}>
                                            <div className="video-verify-date-time-container">
                                                <div className="date-time-container">
                                                    <CalendarOutlined className={'date-time-icon'}/>
                                                    <span className="date-time-info">
                                                    {userDetail?.videoVerificationDate}
                                                </span>
                                                </div>
                                                <div className="date-time-container">
                                                    <ClockCircleOutlined className={'date-time-icon'}/>
                                                    <span className="date-time-info">
                                                    {userDetail?.timeSlot}
                                                </span>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col span={24} style={{marginTop: 12, textAlign: 'center'}}>
                                            <Paragraph copyable={{text: userDetail?.videoVerificationLink}}>Copy Video
                                                Verification
                                                Link.</Paragraph>
                                        </Col>
                                    </Row>
                                </Col> : <></>}
                        </Row>
                    </Card>
                </Col>

                {isJointAccount ?
                    <Col span={24}>
                        <Card title={'Joint Account Details'} className={'joint-applicant-status-info-card'}>

                            <Row gutter={[12, 12]}>
                                <Col span={8}>
                                    <Statistic title="Joint Applicant Name"
                                               value={CommonFunction.validateText(userDetail?.secondApplicantName)}/>
                                </Col>
                                <Col span={8}>
                                    <Statistic title="Mobile Number" formatter={(value: string) => value.replace(',', '')}
                                               value={CommonFunction.validateText(userDetail?.secondApplicantMobileNo)}/>
                                </Col>
                                <Col span={8}>
                                    <Statistic title="Email"
                                               value={CommonFunction.validateText(userDetail?.secondApplicantEmail)}/>
                                </Col>
                                <Col span={8}>
                                    <Statistic title="Reference Number"
                                               formatter={(value: string) => value.replace(',', '')}
                                               value={CommonFunction.validateText(userDetail?.reference)}/>
                                </Col>
                                <Col span={8}>
                                    <Statistic title="Joint Applicant Status" formatter={() => {
                                        return (getJointApplicantStatus(userDetail?.secondApplicantStatus))
                                    }}/>
                                </Col>
                                <Col span={8}>
                                    <Statistic title="Template Status" formatter={() => {
                                        return (<Tag
                                            color={getColorOfJointAccountTemplate(userDetail?.jointTemplateStatus)}>{undefined == userDetail?.jointTemplateStatus ? "Pending" : userDetail?.jointTemplateStatus}</Tag>)
                                    }}/>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    : <></>}
            </Row>
        </div>
    );
};

export default CustomerJourneyStatusViewPage;
